<template>
  <div>
    <q-btn
      label="Adicionar Modelo"
      color="primary"
      icon="add"
      no-caps
      class="btn"
      @click="incluir = !incluir"
    />
    <q-dialog v-model="incluir">
      <q-card style="width: 400px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Adicionar Modelo</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-form ref="adicionarModeloForm">
            <q-input
              outlined
              v-model="adicionarModeloDto.modeloNome"
              label="Nome do Modelo"
              :rules="[(val) => (val && val.length > 0) || 'Campo obrigatório']"
              class="q-mb-md"
            />
          </q-form>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancelar" color="primary" v-close-popup />
          <q-btn
            label="Adicionar"
            color="primary"
            @click="adicionarModelo"
            :loading="loading"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";

export default {
  props: ["unidadeId"],
  emits: ["atualizar"],
  setup(props, { emit }) {
    const incluir = ref(false);
    const loading = ref(false);
    const adicionarModeloForm = ref(null);
    const adicionarModeloDto = ref({
      modeloNome: "",
    });
    const store = useStore();
    const quasar = useQuasar();

    const adicionarModelo = async () => {
      const valido = await adicionarModeloForm.value.validate();
      if (!valido) {
        return;
      }

      try {
        loading.value = true;

        // Obtém dados do usuário logado
        const usuarioLogado = store.getters["autenticacao/usuarioLogado"];

        await store.dispatch("pdt/criarModelo", {
          modeloNome: adicionarModeloDto.value.modeloNome,
          criadorNome: usuarioLogado.name || usuarioLogado.nome || "Sistema",
          criadorMatricula:
            usuarioLogado.email ||
            usuarioLogado.matricula ||
            "sistema@multpex.com.br",
          unidadeId: props.unidadeId,
        });

        resetForm();
        quasar.notify({
          message: "Modelo adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        incluir.value = false;
        emit("atualizar");
      } catch (error) {
        console.error("Erro ao adicionar modelo:", error);
        let message = "Ocorreu um erro ao adicionar o modelo";
        if (error.response) {
          message =
            error.response.data.erros ||
            error.response.data.erro?.mensagem ||
            message;
        }

        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      } finally {
        loading.value = false;
      }
    };

    const resetForm = () => {
      adicionarModeloDto.value = {
        modeloNome: "",
      };
      if (adicionarModeloForm.value) {
        adicionarModeloForm.value.reset();
      }
    };

    return {
      incluir,
      loading,
      adicionarModeloForm,
      adicionarModeloDto,
      adicionarModelo,
    };
  },
};
</script>

<style scoped>
.btn {
  margin-top: 0px;
}
</style>
